import { Wire } from 'src/network/Wire';
import { Arrays, Communication, ResourcePlatform } from 'src/utilities/Helpers';

import { ResourceType } from './Content';
import * as ContentRequest from './dto/ContentRequest';
import { ActionResult } from './Result';

/** This model includes resources and external websites management */
export class Resource {
  private wire: Wire;
  private id: number;

  public some: string;
  constructor(wire: Wire, id: number) {
    this.wire = wire;
    this.id = id;
    this.wire.addRequestTransform((request) => {
      request.bookId = this.id;
      return request;
    });
  }

  openExternalWebsite(externalWebsiteUrl: string): void {
    this.setwebResource(externalWebsiteUrl);
  }

  openResource(data: string) {
    this.setResource(data);
  }

  private downloadFile(rawResource: number[], resourceType: ResourceType, title: string) {
    let arr = Arrays.base64ToArrayBuffer(rawResource.toString());
    let byteArray = new Uint8Array(arr);
    let a = window.document.createElement("a");
    if (resourceType === ResourceType.DOC) {
      a.href = window.URL.createObjectURL(new Blob([byteArray], { type: "application/msword" }));
    } else {
      a.href = window.URL.createObjectURL(new Blob([byteArray], { type: "application/vnd.ms-excel" }));
    }
    a.download = title;
    // Append anchor to body.
    document.body.appendChild(a);
    a.click();
    // Remove anchor from body
    document.body.removeChild(a);
  }

  private async setResource(data: string) {
    let id = 0;
    let args = "";
    if (data.indexOf(",") > -1) {
      let parts = data.split(/,(.+)/);
      id = +parts[0];
      args = parts[1];
    } else {
      id = +data;
    }
    // Thick clients usually
    if (ResourcePlatform.CanOpenDocs()) {
      this.nativeResourceRequested({ StringData: data, Args: args, IsRawUrl: false });
    }
    // Web platform
    else {
      let result = await this.getResource({ Id: id, Args: args });
      if (result.data.ResourceType === ResourceType.DOC || result.data.ResourceType === ResourceType.XLS || result.data.ResourceType === ResourceType.ZIP) {
        this.downloadFile(result.data.RawResource, result.data.ResourceType, result.data.Title);
      } else {
        ResourcePlatform.openNewTabWithContent(ResourcePlatform.getFormattedResource(result.data), "", false, result.data.Title, args);
      }
    }
  }

  private setwebResource(data: string) {
    if (ResourcePlatform.CanOpenWebLinks()) {
      ResourcePlatform.openNewWindowInOtherDomain(data);
    } else {
      this.nativeResourceRequested({ StringData: data, Args: "", IsRawUrl: true });
    }
  }

  async getBookAssets(): Promise<ActionResult<{ stylesheet: string; javascript: string }>> {
    return Communication.handleResponse<ContentRequest.IGetBookAssetsR>(
      this.wire,
      "resource/getBookAssets",
      {},
      (data, result) => {
        result.data = {
          stylesheet: data.Stylesheet,
          javascript: data.Javascript,
        };
      },
      (result) => {
        result.data = {
          stylesheet: "",
          javascript: "",
        };
      }
    );
  }
  async getResource(request: ContentRequest.IGetResource): Promise<ActionResult<ContentRequest.IGetResourceR>> {
    return Communication.handleResponse<ContentRequest.IGetResourceR>(
      this.wire,
      "resource/getResource",
      request,
      (data, result) => {
        result.data = data;
      },
      () => {
        // TODO: handle resource fetch errors.
      }
    );
  }
  private async nativeResourceRequested(request: ContentRequest.INativeResourceRequest): Promise<ActionResult> {
    return Communication.handleResponse<ContentRequest.INativeResourceRequestR>(this.wire, "resource/nativeResourceRequest", request, (data, result) => {
      result.data = data;
    });
  }
}
